import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Router, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface OthersFormProps {
  alignment: string;
}

function EventForm({ alignment }: OthersFormProps) {
  const navigate = useNavigate();
  const [isCancellationEnabled, setIsCancellationEnabled] = useState(false);
  const [isGuestEnabled, setIsGuestEnabled] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);

  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="section_title mn_hdng">
        <h2>Event</h2>
      </div>

      <div className="gap_m avnc_bkng">
        <div className="control_group w_100">
          <div className="gap_m">
            <div className="cncl_plcy control_group w_100">
              <label>Add Guest</label>
              <IosSwitchMain
                checked={isGuestEnabled}
                onChange={(e) => setIsGuestEnabled(e.target.checked)}
              />
            </div>
            {isGuestEnabled && (
              <><div className="control_group w_50">
                <label>No. of Guests</label>
                <TextField placeholder="Enter Number" hiddenLabel fullWidth />
              </div><div className="control_group w_50">
                  <label>Non-Member Price</label>
                  <TextField placeholder="Enter Price" hiddenLabel fullWidth />
                </div></>
            )}
            <div className="w_50 control_group">
              <label>Date</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                    textField: (params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder=" Date"
                        hiddenLabel
                      />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            <div className="w_50 control_group">
              <label> Time</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                    textField: (params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder=" Time"
                        hiddenLabel
                      />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            <div className="control_group w_100">
              <label>Type</label>

              <FormControl className="paid_radio">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Paid"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="Complimentary"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className="control_group w_50">
              <label>Member Price</label>
              <TextField placeholder="Enter Price" hiddenLabel fullWidth />
            </div>



            <div className=" control_group w_100">
              <div className="gap_m">
                <div className="control_group cncl_plcy w_50">
                  <label>Cancellation Policy</label>
                  <IosSwitchMain
                    checked={isCancellationEnabled}
                    onChange={(e) => setIsCancellationEnabled(e.target.checked)}
                  />
                </div>
              </div>
            </div>

            {isCancellationEnabled && (
              <>
                <div className="control_group w_50">
                  <label>Cancellation Amount Per Person</label>
                  <TextField
                    placeholder="Enter cancellation charges"
                    hiddenLabel
                    fullWidth
                  />
                </div>
                <div className="control_group w_50">
                  <label>Cancellation Hours</label>
                  <TextField placeholder="Enter hours" hiddenLabel fullWidth />
                </div>
              </>
            )}
          </div>
        </div>

        <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
          <Tabs
            aria-label="basic tabs example"
            className="custom_tabs_links"
            value={valueTabs}
            onChange={(e, newValue) => setValueTabs(newValue)}
          >
            <Tab {...a11yProps(0)} label="+ Add Custom" />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="control_group w_100 cstm_mn">
            <div className="gap_m">
              <div className="control_group w_50">
                <label>Select Type</label>

                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={value.type}
                  onChange={handleChange1}
                >
                  <MenuItem value="0" disabled>
                    Select Type
                  </MenuItem>

                  <MenuItem value="10"> Checkbox</MenuItem>
                  <MenuItem value="20">Input</MenuItem>
                </Select>
              </div>

              <div className="control_group w_50">
                <label>Enter Question</label>
                <TextField placeholder="Question" hiddenLabel fullWidth />
              </div>
            </div>
          </div>

          <div className="control_group w_100">
            <label>Add Options</label>
            <TextField placeholder="Option Text" hiddenLabel fullWidth />
          </div>
          <div className="control_group w_100 chkbx_mn">
            <FormControlLabel
              control={<Checkbox />}
              name="remember"
              label="Save this question for other offers"
            />
            <Button className="btn btn_primary">+ Add Option</Button>
          </div>


        </CustomTabPanel>

        <div className="btn_flex flx_end">
          {alignment === "archived" && (
            <Button
              className="btn btn_primary"
              onClick={() =>
                navigate("/manage-offer")
              }
            >
              Save & Exit
            </Button>
          )}
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-offer/preview-offer?mode=EVENTS")}
          >
            Preview
          </Button>
        </div>
      </div>
    </>
  );
}

export default EventForm;
